import { render, staticRenderFns } from "./ConfiguratorSelection.vue?vue&type=template&id=93053be2&scoped=true&"
import script from "./ConfiguratorSelection.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguratorSelection.vue?vue&type=style&index=0&id=93053be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93053be2",
  null
  
)

export default component.exports